import { Injectable, Injector, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map  } from 'rxjs/operators';
import { NotificationsService } from '@app/core-notifications/services/notifications.service';

@Injectable()
export class HttpNotifyInterceptor implements HttpInterceptor {
    private ns = inject(NotificationsService);


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const showNotify = req.url.indexOf(':silent:') === -1;
        if (!showNotify) {
            return next.handle(req.clone({url: req.url.split(':silent:').join('')}));
        }
        return next.handle(req).pipe(map(
                (response) => {
                    if (response instanceof HttpResponse) {
                        if (response.body && response.body['message']) {
                            const msg = response.body['message'];
                            this.ns.success('', response.body['message']);
                        }
                    }
                    return response;
                }
            ));
    }
}
